

export class OperatorReworkModel {
    operatorId: string;
    operatorName: string;

    operationId: string;
    operationDesc: string;
    totalCompletedGarments: number;
    reworkGarments: number; // total rework 
    isLastOp: boolean;
    eff: number; // must be calculated based on the style + operation smv + actual smv(hanger in - hanger out) * no of garments

    constructor(operatorId: string,
        operatorName: string,
        operationId: string,
        operationDesc: string,
        totalCompletedGarments: number,
        reworkGarments: number, 
        isLastOp: boolean, eff: number) {
            this.operatorId = operatorId;
            this.operatorName = operatorName;
            this.operationId = operationId;
            this.operationDesc = operationDesc;
            this.totalCompletedGarments = totalCompletedGarments;
            this.isLastOp = isLastOp;
            this.eff = eff;
            this.reworkGarments = reworkGarments;
    }
}
